import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import clsx from 'clsx';
import Hr from 'core/modules/atoms/Hr';
import Icon from 'core/modules/atoms/Icon';
import HeaderTabs from 'core/modules/components/tabs/HeaderTabs';
import FooterButtons from 'core/modules/compositions/FooterButtons';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

const DialogDefault = ({
  t,
  open,
  onClose,
  title,
  iconTitle,
  text,
  buttonIconSucess,
  buttonTextCancel = t('actions:Cancel'),
  buttonTextSucess = t('actions:Confirm'),
  loading,
  onSuccess,
  onCancel,
  disabledSuccess,
  children,
  className,
  separator,
  showHeader,
  customHeader,
  footerWithBackground,
  customFooterLeft,
  size,
  tabs,
  tabActive,
  onChangeTab,
  hideHeader,
  ...props
}) => {
  const { ...propsDialog } = props;

  return (
    <Dialog
      disableEnforceFocus={true}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={false}
      className={clsx('dialog', className, `dialog--size-${size}`, {
        'dialog--with-footer-with-background': footerWithBackground,
        'dialog--with-icon': iconTitle,
      })}
      {...propsDialog}
    >
      {!hideHeader && (title || onClose || customHeader) && showHeader && (
        <div className="dialog__header">
          <div className="dialog__title-container">
            {title && (
              <div className="dialog__title-wrapper">
                {iconTitle && <Icon type={iconTitle} color="primary" />}
                <span className="dialog__title">{title}</span>
              </div>
            )}
            {tabs && (
              <div className="dialog__title-tabs">
                <HeaderTabs tabs={tabs} tabActive={tabActive} onChangeTab={onChangeTab} />
              </div>
            )}
            <div className="dialog__close-container">
              {onClose && (
                <div className="dialog__close">
                  <button onClick={onClose}>
                    <Icon size="big" type="close" />
                  </button>
                </div>
              )}
            </div>
          </div>
          {text && <span className="dialog__text">{text}</span>}
          {customHeader && <div className="dialog__custom-header">{customHeader}</div>}
          {separator && (
            <div className="dialog__hr">
              <Hr size="small" />
            </div>
          )}
        </div>
      )}
      {children && <DialogContent>{children}</DialogContent>}
      {(onSuccess || onCancel) && (
        <DialogActions>
          <div className="dialog__actions">
            <div className="dialog__actions-left">{customFooterLeft}</div>
            <FooterButtons
              buttonIconSucess={buttonIconSucess}
              buttonTextCancel={buttonTextCancel}
              buttonTextSucess={buttonTextSucess}
              loading={loading}
              onSuccess={onSuccess}
              onCancel={onCancel}
              disabledSuccess={disabledSuccess}
            />
          </div>
        </DialogActions>
      )}
    </Dialog>
  );
};

DialogDefault.propTypes = {
  buttonIconSucess: PropTypes.string,
  buttonTextCancel: PropTypes.string,
  buttonTextSucess: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  customFooterLeft: PropTypes.node,
  customHeader: PropTypes.node,
  disabledSuccess: PropTypes.bool,
  footerWithBackground: PropTypes.bool,
  hideHeader: PropTypes.bool,
  iconTitle: PropTypes.string,
  loading: PropTypes.bool,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  separator: PropTypes.bool,
  showHeader: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'xxs', 'xs', 's', 'small', 'xl', 'xxl', 'all-screen']),
  text: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  tabActive: PropTypes.number,
  tabs: PropTypes.array,
  onChangeTab: PropTypes.func,
  t: PropTypes.func.isRequired,
};

DialogDefault.defaultProps = {
  loading: false,
  open: false,
  showHeader: true,
  disabledSuccess: false,
  size: 'default',
  hideHeader: false,
};

export default withTranslation(['common', 'actions', 'placeholder', 'types-resources'])(DialogDefault);
